import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { FaTimes } from 'react-icons/fa';

/**
 * Renders a modal component with the given props.
 *
 * @param {Object} props - The props object containing the following properties:
 *   - closeModal: A function to close the modal. (CURRENTLY NOT USED DUE TO CLIENT PETITION) 
 *   - isOpen: A boolean indicating whether the modal is open or not.
 *   - width: The width of the modal (optional).
 *   - children: The content of the modal.
 *   - title: The title of the modal.
 * @return {JSX.Element} The rendered modal component.
 */
export default function Modal({ closeModal, isOpen, width, children, title }) {
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-50 modal" onClose={() => {}}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-300"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel
                  className={` w-full ${
                    width ? width : 'max-w-6xl'
                  } transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all`}
                >
                  <div className="w-full flex-btn gap-2 mb-8">
                    <h1 className="text-xl font-semibold">{title}</h1>
                    <button
                      onClick={closeModal}
                      className="w-14 h-12 bg-dry text-red-600 rounded-md flex-colo"
                    >
                      <FaTimes />
                    </button>
                  </div>
                  {children}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
